import Vue from "vue"
import Router from "vue-router"
import Home from "./components/Home.vue"
import Contact from "./components/Contact.vue"
import Chat from "./components/Chat.vue"
import Reset from "./components/Reset.vue"
import Forgot from "./components/Forgot.vue"
import Group from "./components/Group.vue"
import Post from "./components/Post.vue"
import Privacy from "./components/Privacy.vue"
import WAPrivacy from "./components/WAPrivacy.vue"
import SocialPrivacy from "./components/SocialPrivacy.vue"
import Four from "./components/Four.vue"
import QrCode from "./components/QrCode.vue"


Vue.use(Router)

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: Home
    },
    {
      path: "/qr/:id",
      name: "qrCode",
      component: QrCode
    },
    {
      path: "/g/:id/:name",
      name: "group",
      component: Group
    },
    {
      path: "/p/:id",
      name: "post",
      component: Post
    },
    {
      path: "/web/contact",
      name: "contact",
      component: Contact
    },
    {
      path: "/web/reset/:username/:token",
      name: "reset",
      component: Reset
    },
    {
      path: "/web/forgot",
      name: "forgot",
      component: Forgot
    },
    {
      path: "/web/privacy",
      name: "privacy",
      component: Privacy
    },
    {
      path: "/web/wa/privacy",
      name: "waPrivacy",
      component: WAPrivacy
    },
    {
      path: "/web/social/privacy",
      name: "socialPrivacy",
      component: SocialPrivacy
    },
    {
      path: "/:username",
      name: "chat",
      component: Chat
    },
    {
      path: "/*",
      name: "404",
      component: Four
    }
  ]
})
